import React, {useState, useEffect} from 'react';
import Form from './components/form'
import Lista from './components/list'

function App() {
  const[search, saveSearch] = useState('');
  const[image, saveImage] = useState([]);
  const[actualpg, savePg] = useState(1);
  const[totalpg, saveTotal] = useState(5);

  useEffect(() => {
    const Apiconsult = async () => {
      if(search === ''){
        return;
      }
      const imgporpg = 30;
      const key = '19088610-928ed158692387ac95409df93'
      const url = `https://pixabay.com/api/?key=${key}&q=${search}&per_page=${imgporpg}&page=${actualpg}`;

      const answer = await fetch(url);
      const resp = await answer.json();
      saveImage(resp.hits);

      const numberPages = Math.ceil(resp.totalHits / imgporpg);
      saveTotal(numberPages);

      const jumbotron = document.querySelector('.jumbotron');
      jumbotron.scrollIntoView({behavior: 'smooth'})
    }
    Apiconsult();
  },[search, actualpg])

      const lastPag = () => {
        const newactualpg = actualpg - 1;
        if(newactualpg === 0) {
          return;
        }
        savePg(newactualpg);
      }

      const nextPg = () => {
        const newactualpg = actualpg + 1;
        if (newactualpg > totalpg) {
          return;
        }
        savePg(newactualpg);
      }
  return (
    <div className="container">
      <div className="jumbotron">
        <p className="lead text-center ">Image finder</p>
        <Form 
          saveSearch={saveSearch}
        />
      </div>
      <div className="row justify-content-center">
        <Lista 
          image={image}
        />
        { (actualpg === 1) ? null : (
                  <button 
                  type="button"
                  className="bbtn btn-info mr-1"
                  onClick={lastPag}
                  > &laquo; Last pg </button>
        )}
        {(actualpg === totalpg) ? null : 
           <button 
           type="button"
           className="bbtn btn-info"
           onClick={nextPg}
           > Next pg &raquo;</button>
        }
      </div>
    </div>
  );
}

export default App;
